module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/7-2c18a7e3d3ce9e57b3a424dca1ec9989.png";